import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export const UsersPage: React.FC = () => {
  const [userId, setUserId] = useState('');
  const navigate = useNavigate();

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (userId.trim()) {
      navigate(`/admin/users/${userId.trim()}`);
    }
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>User Management</h1>

      <div style={styles.searchCard}>
        <h2 style={styles.searchTitle}>Search User by ID</h2>
        <p style={styles.searchDescription}>
          Enter a user ID to view their details, risk assessment, and manage their account.
        </p>

        <form onSubmit={handleSearch} style={styles.searchForm}>
          <input
            type="text"
            value={userId}
            onChange={(e) => setUserId(e.target.value)}
            placeholder="Enter user ID (UUID)"
            style={styles.searchInput}
          />
          <button type="submit" style={styles.searchButton}>
            Search
          </button>
        </form>
      </div>

      <div style={styles.infoCard}>
        <h3 style={styles.infoTitle}>💡 Quick Tips</h3>
        <ul style={styles.infoList}>
          <li>User IDs can be found in reports or audit logs</li>
          <li>Click on user emails in the reports page to view their details</li>
          <li>You can ban or unban users from their detail page</li>
          <li>View risk scores and session history for any user</li>
        </ul>
      </div>
    </div>
  );
};

const styles: { [key: string]: React.CSSProperties } = {
  container: {
    maxWidth: '800px',
  },
  title: {
    fontSize: '2rem',
    fontWeight: '700',
    color: '#1e293b',
    marginBottom: '2rem',
  },
  searchCard: {
    backgroundColor: 'white',
    borderRadius: 'var(--radius-lg)',
    padding: '2rem',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
    marginBottom: '2rem',
  },
  searchTitle: {
    fontSize: '1.25rem',
    fontWeight: '600',
    color: '#1e293b',
    marginBottom: '0.5rem',
  },
  searchDescription: {
    fontSize: '0.95rem',
    color: '#6b7280',
    marginBottom: '1.5rem',
  },
  searchForm: {
    display: 'flex',
    gap: '1rem',
  },
  searchInput: {
    flex: 1,
    padding: '0.875rem',
    border: '2px solid #e5e7eb',
    borderRadius: 'var(--radius-md)',
    fontSize: '0.95rem',
  },
  searchButton: {
    padding: '0.875rem 2rem',
    backgroundColor: '#3b82f6',
    color: 'white',
    border: 'none',
    borderRadius: 'var(--radius-md)',
    fontSize: '0.95rem',
    fontWeight: '600',
    cursor: 'pointer',
  },
  infoCard: {
    backgroundColor: '#eff6ff',
    borderRadius: 'var(--radius-lg)',
    padding: '1.5rem',
    border: '1px solid #bfdbfe',
  },
  infoTitle: {
    fontSize: '1rem',
    fontWeight: '600',
    color: '#1e40af',
    marginBottom: '1rem',
  },
  infoList: {
    margin: 0,
    paddingLeft: '1.5rem',
    fontSize: '0.9rem',
    color: '#1e3a8a',
    lineHeight: '1.8',
  },
};
